import { motion } from "framer-motion";
import type { ReactNode, CSSProperties } from "react";

export interface RotateTransitionProps {
  rotated: boolean;
  children: ReactNode;
  degrees?: number;
  duration?: number;
  className?: string;
  style?: CSSProperties;
  "data-testid"?: string;
}

const RotateTransition = ({
  rotated,
  children,
  degrees = 180,
  duration = 0.25,
  className,
  style,
  "data-testid": dataTestId
}: RotateTransitionProps) => {
  return (
    <motion.span
      animate={{ rotate: rotated ? degrees : 0 }}
      transition={{ duration, ease: "easeInOut" }}
      className={className}
      style={{ display: "inline-grid", placeItems: "center", ...style }}
      data-testid={dataTestId ?? "rotate-transition"}
    >
      {children}
    </motion.span>
  );
};

export default RotateTransition;
